import { Component, EventEmitter, Input, Output } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';

import { UserService } from 'app/_core/services/user.service';

@Component({
  selector: 'app-user-filters',
  templateUrl: './user-filters.component.html',
  styleUrls: ['./user-filters.component.scss'],
  standalone: false,
})
export class UserFiltersComponent {
  @Input() createPermissions: boolean;
  @Input() formGroup: UntypedFormGroup;
  @Output() searchedValue: EventEmitter<string> = new EventEmitter<string>();

  constructor(
    public userService: UserService,
    protected route: ActivatedRoute
  ) {}

  /**
   * Emitts value to parent component (user-list)
   * @param value - emitted value from search-control component
   */
  onSearch(value: string): void {
    this.searchedValue.emit(value);
  }
}
